import { Tabs, TabsProps } from "antd";
import StockManagment from "./StockManagment";
import UpdateStock from "./UpdateStock";
import SheetImport from "./SheetImport";

const Tools = () => {
    const onChange = (key: string) => {
        console.log(key);
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Levizje Interne',
            children: <StockManagment />
        },
        {
            key: '2',
            label: 'Ndryshim stoku',
            children: <UpdateStock />,
        },
        {
            key: '3',
            label: 'Import Sheet',
            children: <SheetImport />,
        }
    ];
    return (
        <div className="container">
            <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
        </div>

    )
}

export default Tools;